/**
 * A medicine library product found by `GET v2/medication/search` (#333).
 * The SEP file's product name often has no strength, so `strength` comes from the ingredients.
 */
export interface MedicineLibraryProductMatch {
  /** Stored on a practice list item or script line as its `productId`. */
  productId: number;
  proprietaryName: string;
  /** Each ingredient's strength and unit in order, e.g. "80mg / 5mg"; empty when the file has none. */
  strength: string;
  dosageForm: string;
  atcCode: string | null;
  schedule: string | null;
  /** Every pack is marked discontinued in the current edition. Still shown: patients keep taking them. */
  isDiscontinued: boolean;
  /** Found by the spelling-tolerant fallback, not by every query word matching. */
  isCloseMatch: boolean;
}

/**
 * The description a library pick starts with, e.g. "Glucophage 850mg": the name plus the strength when the
 * name doesn't already contain it. The clinician can still edit it in the add card; the text is what every
 * report, script and referral prints, the productId is the link.
 */
export function libraryProductDescription(product: MedicineLibraryProductMatch): string {
  const name = (product.proprietaryName ?? '').trim();
  const strength = (product.strength ?? '').trim();
  if (strength.length === 0 || name.toLowerCase().includes(strength.toLowerCase())) {
    return name;
  }
  return `${name} ${strength}`;
}
